<ng-container *ngrxLet="password$; let password">
  @switch (passwordState$ | async) {
    @case (LoadingState.initial) {
      <span
        class="link"
        data-qa="dashboard.generate-new-password.button"
        translate="account.link.generate-password"
        [gaEventOptions]="{
                        context: 'account_details',
                        object: 'mt5PasswordGenerate',
                        button_id: 'dashboard.generate-new-password.button'
                      }"
        [pagGaEventClick]="eventType.InteractiveClick"
    (click)="generatePassword()"
      ></span>
    }
    @case (LoadingState.loading) {
      <img
        alt="Loading"
        src="assets/img/dot-loader.svg"
        >
    }
    @case (LoadingState.loaded) {
      <span data-qa="dashboard.account-password.text">{{password}}</span>
      <tooltip-copy-link
        type="icon"
        [copiedTooltipLabel]="'register-account-certificate.tooltip.copied' | translate"
        [text]="password"
      />
    }
    @case (LoadingState.failed) {
      <span
        class="error"
        data-qa="dashboard.account-password-error.text"
        translate="account.error.password-request"
      ></span>
    }
  }
</ng-container>
